import { baseUrl } from "../../../shared/config";
import { useStudentGamePanel } from "../api/getStudentGamePanel";

import SideBarSection from "./SideBarSection";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
export default function StudentGames({ studentId }) {
  const gameAchievementsQuery = useStudentGamePanel({ studentId });

  return (
    <SideBarSection title={"Games"}>
      <List className="user_info_section_games">
        {gameAchievementsQuery.data?.map((game) => {
          const medals = game?.Medalhas?.split(";").map((foo) => {
            return {
              name: foo.split("|")[0],
              pictureUrl: `${baseUrl}` + foo.split("|")[1],
            };
          });

          const gamePicture = `${baseUrl}/${game?.fotoGame.replace(
            "membros",
            "Membros"
          )}`;

          return (
            <>
              <ListItem>
                <ListItemAvatar>
                  <Avatar src={gamePicture} />
                </ListItemAvatar>
                <ListItemText
                  secondary={`${game.total_pontos || 0} pontos - N.º ${
                    game.posicaoRanking
                  } no ranking`}
                >
                  {game.nomeGame}
                </ListItemText>
              </ListItem>
              <span>
                <List component="div" disablePadding>
                  {medals?.map((medal) => {
                    return (
                      <ListItem sx={{ paddingLeft: 4 }}>
                        <ListItemAvatar>
                          <Avatar src={medal?.pictureUrl} />
                        </ListItemAvatar>
                        <ListItemText>{medal?.name}</ListItemText>
                      </ListItem>
                    );
                  })}
                </List>
              </span>
            </>
          );
        })}
      </List>
    </SideBarSection>
  );
}
